import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import styles from './styles.module.css'
import { useLocation, useNavigate } from "react-router-dom";
import { toggleModal as toggleDuonutModal, updateSettings } from "../../redux/slices/duonutSettings";
import { openModal, showSignInForm } from "../../redux/slices/formDetails";
import { updateSuccessModal } from "../../redux/slices/userActivity";
import { toast } from "react-toastify";

import { editActivities, publishActivities } from "../../services/activity";
import { toDataUrl } from "../../utils";

export default function PublishButton({ className, handleClose, setError }) {
  const [publishing, setPublishing] = useState(false);
  const { categories, duonutToEdit, coverPhoto } = useSelector((state) => state.duonutSettings);
  const { userActivities, isEditing, isVideo } = useSelector((state) => state.userActivity);
  const { title, description, isPublic, category } = useSelector((state) => state.duonutSettings.settings);
  const { isLoggedIn } = useSelector((state) => state.user);
  const { modalOpen } = useSelector((state) => state.duonutSettings);
  const [displayMessage, setDisplayMessage] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { video, video_url } = useSelector((state) => state.duonutSettings.settings);

  let interval = null;
  let timeout = null
  useEffect(() => {
    // console.log('UE RUN ----')
    // clearInterval(interval);
    // return
    if (location.pathname.substring(0, 7) === "/design" && location.pathname.length >= 8) {
      interval = setInterval(() => {
        // console.log('f')
        // handlePublish(true)
        // console.log(duonutToEdit)
        clearInterval(interval);
        let reqBody = {};
        reqBody.masters_data = [...userActivities];
        // console.log(userActivities);
        //remove empty activities

        reqBody.masters_data = reqBody.masters_data.filter((item, idx) => {
          return Object.keys(item).length > 2;
        });

        let thumbnails = reqBody.masters_data.map((item) => {
          if (item.theme_id.thumbnail_data) {
            return { thumbnail: null, thumbnail_data: item.theme_id.thumbnail_data };
          } else {
            return { thumbnail: item.theme_id.thumbnail };
          }
        });

        reqBody.masters_data = reqBody.masters_data.map((item, idx) => {
          let master = { ...item };
          delete master["duonut_id"];
          master.priority = idx;
          return { ...master };
        });

        let duonut_id = {
          duonutthumbnail_set: thumbnails,
          name: title,
          description,
          duonut_category: parseInt(category),
          video_url: video_url,
          video: video,
          timestamps: null,
          visibility: isPublic,
          priority: 1,
          ...(Object.keys(coverPhoto).length !== 0 && { thumbnail_data: coverPhoto }),
        };
        reqBody.duonut_id = duonut_id;
        let editReqBody = { id: duonutToEdit.id, ...reqBody.duonut_id, masters_data: reqBody.masters_data };
        let selectedCategory = categories.find((category) => category.id === duonut_id.duonut_category);
        let duonut_category_id = {
          ...duonutToEdit.duonut_category_id,
          id: selectedCategory.id,
          name: selectedCategory.value,
        };
        editReqBody.duonut_category_id = duonut_category_id;
        editReqBody.duonutthumbnail_set = editReqBody.duonutthumbnail_set.map((thumbnail, idx) => {
          if (duonutToEdit.duonutthumbnail_set[idx]) {
            return { ...duonutToEdit.duonutthumbnail_set[idx], ...thumbnail };
          } else {
            return { ...thumbnail };
          }
        });
        delete editReqBody["duonut_category"];
        // console.log(editReqBody);
        console.log('EDITING -----');
        if (isVideo) {
          if (editReqBody.video instanceof File) {
            toDataUrl(editReqBody.video, (res => {
              let reqBodyNew = {}
              reqBodyNew = {
                ...editReqBody, video_data: {
                  uri: res,
                  name: 'video'
                }
              }
              delete reqBodyNew['video']
              let timestamps = []
              reqBodyNew.masters_data.forEach((master, idx) => {
                timestamps.push({ idx, timestamp: master.question_id.timestamp })
              })
              reqBodyNew.timestamps = timestamps
              console.log('reqBodyNew', reqBodyNew);
              editActivities(duonutToEdit.id, reqBodyNew, (err, res) => {
                setPublishing(false);
                clearInterval(interval);
                // console.log(res.data);
                setDisplayMessage(true)
                timeout = setTimeout(() => {
                  setDisplayMessage(false)
                }, 3000);
                if (err) return console.log(err.response);
              });
            }))
          } else {
            let reqBodyNew = {}
            reqBodyNew = {
              ...editReqBody
            }
            let timestamps = []
            reqBodyNew.masters_data.forEach((master, idx) => {
              timestamps.push({ idx, timestamp: master.question_id.timestamp })
            })
            reqBodyNew.timestamps = timestamps
            console.log('reqBodyNew', reqBodyNew);
            editActivities(duonutToEdit.id, reqBodyNew, (err, res) => {
              setPublishing(false);
              clearInterval(interval);
              // console.log(res.data);
              setDisplayMessage(true)
              timeout = setTimeout(() => {
                setDisplayMessage(false)
              }, 3000);
              if (err) return console.log(err.response);
              // console.log("autosaved");
            });
          }
        } else {

          editActivities(duonutToEdit.id, editReqBody, (err, res) => {
            setPublishing(false);
            clearInterval(interval);
            // console.log(res.data);
            setDisplayMessage(true)
            timeout = setTimeout(() => {
              setDisplayMessage(false)
            }, 3000);
            if (err) return console.log(err.response);
            // alert(`${duonutToEdit.name} Duonut edited successfully!`);
          });
        }
      }, 5000);


      return () => {
        clearInterval(interval)
        clearTimeout(timeout)
      };
    }
  }, [location.pathname, userActivities, description, category, title, isPublic, coverPhoto, categories, duonutToEdit,video_url, video]);

  const handleClick = () => dispatch(openModal());
  // console.log(duonutToEdit)
  const handlePublish = () => {
    if (!isLoggedIn) {
      handleClick();
      dispatch(showSignInForm());
      return;
    }
    if (!title && !modalOpen) return dispatch(toggleDuonutModal());
    if (!title) return setError(true);
    setError(false);
    setPublishing(true);
    let reqBody = {};
    reqBody.masters_data = [...userActivities];

    //remove empty activities
    reqBody.masters_data = reqBody.masters_data.filter((item, idx) => {
      return Object.keys(item).length > 2;
    });

    let thumbnails = reqBody.masters_data.map((item) => {
      if (item.theme_id.thumbnail_data) {
        // Change Here
        return { thumbnail: null, thumbnail_data: item.theme_id.thumbnail_data };
      } else {
        return { thumbnail: item.theme_id.thumbnail };
      }
    });
    // console.log(thumbnails);

    reqBody.masters_data = reqBody.masters_data.map((item, idx) => {
      let master = { ...item };
      delete master["duonut_id"];
      master.priority = idx;
      return { ...master };
    });
    let duonut_id = {
      duonutthumbnail_set: thumbnails,
      name: title,
      description,
      duonut_category: parseInt(category),
      video_url: video_url,
      video: video,
      timestamps: null,
      visibility: isPublic,
      priority: 1,
      published: true,
      ...(Object.keys(coverPhoto).length !== 0 && { thumbnail_data: coverPhoto }),
    };
    reqBody.duonut_id = duonut_id;

    if (isEditing) {
      let editReqBody = { id: duonutToEdit.id, ...reqBody.duonut_id, masters_data: reqBody.masters_data };
      let selectedCategory = categories.find((category) => category.id === duonut_id.duonut_category);
      let duonut_category_id = {
        ...duonutToEdit.duonut_category_id,
        id: selectedCategory.id,
        name: selectedCategory.value,
      };
      editReqBody.duonut_category_id = duonut_category_id;
      editReqBody.duonutthumbnail_set = editReqBody.duonutthumbnail_set.map((thumbnail, idx) => {
        if (duonutToEdit.duonutthumbnail_set[idx]) {
          return { ...duonutToEdit.duonutthumbnail_set[idx], ...thumbnail };
        } else {
          return { ...thumbnail };
        }
      });
      delete editReqBody["duonut_category"];
      console.log('editReqBody', editReqBody);
      // console.log('isVideo', isVideo);
      // return
      if (isVideo) {
        if (editReqBody.video instanceof File) {
          toDataUrl(editReqBody.video, (res => {
            let reqBodyNew = {}
            reqBodyNew = {
              ...editReqBody, video_data: {
                uri: res,
                name: 'video'
              }
            }
            delete reqBodyNew['video']
            let timestamps = []
            reqBodyNew.masters_data.forEach((master, idx) => {
              timestamps.push({ idx, timestamp: master.question_id.timestamp })
            })
            reqBodyNew.timestamps = timestamps
            console.log('reqBodyNew', reqBodyNew);

            editActivities(duonutToEdit.id, reqBodyNew, (err, res) => {
              setPublishing(false);
              if (err) return console.log(err.response);
              console.log('success', res.data);
              // alert(`${duonutToEdit.name} Duonut edited successfully!`);
              dispatch(updateSuccessModal({ active: true, message: "Yayy! Your Duonut has been edited successfully.", isEdited: true }));
              resetUserActivities();
              handleClose();

              // console.log("autosaved");
            });

          }))
        } else {
          let reqBodyNew = {}
          reqBodyNew = {
            ...editReqBody
          }
          let timestamps = []
          reqBodyNew.masters_data.forEach((master, idx) => {
            timestamps.push({ idx, timestamp: master.question_id.timestamp })
          })
          reqBodyNew.timestamps = timestamps
          console.log('reqBodyNew', reqBodyNew);
          editActivities(duonutToEdit.id, reqBodyNew, (err, res) => {
            setPublishing(false);
            if (err) return console.log(err.response);
            console.log('success', res.data);
            // alert(`${duonutToEdit.name} Duonut edited successfully!`);
            dispatch(updateSuccessModal({ active: true, message: "Yayy! Your Duonut has been edited successfully.", isEdited: true }));
            resetUserActivities();
            handleClose();

            // console.log("autosaved");
          });
        }

      } else {

        editActivities(duonutToEdit.id, editReqBody, (err, res) => {
          setPublishing(false);
          if (err) return console.log(err.response);
          console.log(res.data);
          // alert(`${duonutToEdit.name} Duonut edited successfully!`);
          dispatch(updateSuccessModal({ active: true, message: "Yayy! Your Duonut has been edited successfully.", isEdited: true }));
          resetUserActivities();
          handleClose();

          console.log("autosaved");
        });
      }
    } else {
      // console.log('reqBody', reqBody);
      let reqBodyNew = {}

      toDataUrl(reqBody.duonut_id.video, (res => {
        reqBodyNew = { ...reqBody, duonut_id: { ...reqBody.duonut_id, video: res } }

        let timestamps = []
        reqBodyNew.masters_data.forEach((master, idx) => {
          timestamps.push({ idx, timestamp: master.question_id.timestamp })
        })
        reqBodyNew.duonut_id.timestamps = timestamps
        // console.log('reqBodyNew', reqBodyNew);

      }))

      if (isVideo) {
        // return
        publishActivities(reqBodyNew, (err, res) => {
          if (err) {
            console.log(err.response);
            setPublishing(false);
            return;
          }
          // alert(`${res.data.duonut_id.name} Duonut created successfully!`);
          dispatch(updateSuccessModal({ active: true, message: "Yayy! Your Duonut has been published." }));
          console.log(res.data);
          setPublishing(false);
          resetUserActivities();
          // navigate('/myduonuts')
          handleClose();
        });
      } else {
        return
        publishActivities(reqBody, (err, res) => {
          if (err) {
            console.log(err.response);
            setPublishing(false);
            return;
          }
          // alert(`${res.data.duonut_id.name} Duonut created successfully!`);
          dispatch(updateSuccessModal({ active: true, message: "Yayy! Your Duonut has been published." }));
          console.log(res.data);
          setPublishing(false);
          resetUserActivities();
          // navigate('/myduonuts')
          handleClose();
        });
      }

    }
  };

  const resetUserActivities = () => {
    localStorage.removeItem("userActivities");
    localStorage.removeItem("duonutSettings");
    if (modalOpen) {
      dispatch(toggleDuonutModal());
    }
  };

  return (
    <>
      <button
        className={`publish-btn ${className} `}
        disabled={publishing ? true : false}
        onClick={handlePublish}
      // id={title.trim().length === 0 ? 'disabled' : ''}
      >
        {publishing ? "Publishing..." : "Publish"}
      </button>
      {
        displayMessage &&
        <div className={styles.message}>
          Your changes have been autosaved!
        </div>
      }
    </>
  );
}
